import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../../../firebase'
import StateContext from '../../../../StateContext'



function TeamSquadListTemplate({player, mode, teamId}) {

    const appState = useContext(StateContext)

    async function removeFromSquadHandler() {
        if (!player) {
            console.log("No doc found")
            return
        }
        try {
            const playerSquadRef = firestore.collection("teams").doc(teamId).collection("team-squads").doc(player.id)
            playerSquadRef.delete()
            console.log("DELETED")
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="col-4 col-md-3 col-lg-2 my-2">
            <div className="card">
                <Link to={`/players/${player.player_parent_id}`}>
                    <img src={player.player_image} alt={player.player_name} className="img-fluid player-image" />
                </Link>
                <div className="card-body">
                    <small className="player-name font-weight-bold">{player.player_name}</small>
                    {mode === "edit" && appState.loggedIn && (
                        <p>                                       
                            <Link to={`/edit-player/${player.player_parent_id}`} className="float-right"><i className="fas fa-edit"></i></Link>
                            <button onClick={removeFromSquadHandler}>Fjern</button>
                        </p>
                    )}
                </div>
            </div>
        </div>
    )
}
export default TeamSquadListTemplate